import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Creador() {
  return <section id="autor" className="bg-verde-oscuro py-[100px]" data-id="element-105">
      <div className="container-wide" data-id="element-106">
        <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-[60px] items-center text-center md:text-left" data-id="element-107">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-108">
            <div className="w-[240px] h-[280px] rounded-[8px] bg-white/5 border-2 border-dorado/30 overflow-hidden relative" data-id="element-109">
              <img src="https://i.postimg.cc/FRmCJJBj/escritor.webp" alt="Hugo Pagano" className="w-full h-full object-cover" loading="lazy" data-id="element-110" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-111">
            <div className="inline-block bg-dorado/15 text-dorado-claro text-[12px] font-semibold tracking-[2px] uppercase px-4 py-1.5 rounded-[2px] mb-5" data-id="element-112">
              El creador
            </div>
            <h2 className="font-display text-[clamp(28px,4vw,44px)] font-bold text-blanco mb-3" data-id="element-113">
              Hugo Pagano
            </h2>
            <div className="text-[15px] md:text-[14px] font-semibold tracking-[2px] uppercase text-dorado mb-6" data-id="element-114">
              Especialista en salud digestiva natural
            </div>

            <p className="text-[16px] text-white/70 leading-[1.8] mb-4" data-id="element-115">
              Hugo Pagano lleva años investigando y aplicando protocolos de
              salud digestiva basados en evidencia y enfoques naturales. Después
              de ver a miles de personas atrapadas en el ciclo del medicamento
              permanente — alivio momentáneo, regreso del problema, más
              medicamento — desarrolló el{' '}
              <strong className="text-dorado-claro font-semibold" data-id="element-116">
                Protocolo Digestivo de 72 Horas™
              </strong>
              : un sistema estructurado que aborda las causas reales del
              reflujo, no solo los síntomas.
            </p>
            <p className="text-[16px] text-white/70 leading-[1.8] mb-8" data-id="element-117">
              Su enfoque está fundamentado en la fisiología del sistema
              digestivo: entender que el reflujo crónico no es una enfermedad
              sino una señal de un proceso digestivo desregulado que, con los
              ajustes correctos, puede estabilizarse sin depender de medicación
              de por vida.
            </p>

            <div className="flex flex-wrap gap-3 justify-center md:justify-start" data-id="element-118">
              <span className="bg-dorado/10 border border-dorado/25 text-dorado-claro text-[15px] md:text-[14px] font-medium px-4 py-2 rounded-[4px]" data-id="element-119">
                Salud digestiva natural
              </span>
              <span className="bg-dorado/10 border border-dorado/25 text-dorado-claro text-[15px] md:text-[14px] font-medium px-4 py-2 rounded-[4px]" data-id="element-120">
                Protocolo Digestivo de 72 Horas™
              </span>
              <span className="bg-dorado/10 border border-dorado/25 text-dorado-claro text-[15px] md:text-[14px] font-medium px-4 py-2 rounded-[4px]" data-id="element-121">
                Enfoque basado en causas
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}